import React from 'react';
import {
  prepareCategories,
  prepareSeries,
  preparePoints,
  prepareLine,
  prepareLineSeries,
  prepareStacked
} from './charts';
import MapViz from './viz/MapViz';
import ScatterViz from './viz/ScatterViz';
import LineViz from './viz/LineViz';
import PieViz from './viz/PieViz';
import BarViz from './viz/BarViz';
import RadarViz from './viz/RadarViz';
import TableViz from './viz/TableViz';
import HeatmapViz from './viz/HeatmapViz';
import MatrixViz from './viz/MatrixViz';
import { fieldLabel } from './viz/builders';

// Renders the stored pipeline result (rows + schema) with the chart type
// and config of one visualization. A config.seriesField splits rows into
// multiple visually distinct datasets (the `series` workflow node adds
// that column).
export default function Viz({ chartType, rows, fields, config, viz }) {
  switch (chartType) {
    case 'map':
      return <MapViz rows={rows} fields={fields} config={config} />;
    case 'heatmap':
      return <HeatmapViz heatmaps={(viz && viz.heatmaps) || []} />;
    case 'matrix':
      return <MatrixViz rows={rows} />;
    case 'scatter': {
      const cfg = config || {};
      return (
        <ScatterViz
          points={preparePoints(rows, fields, config)}
          xLabel={fieldLabel(fields, cfg.x)}
          yLabel={fieldLabel(fields, cfg.y)}
        />
      );
    }
    case 'line': {
      const multi = prepareLineSeries(rows, fields, config);
      return (
        <LineViz data={multi || prepareLine(rows, fields, config)} label={config && config.y} />
      );
    }
    case 'pie': {
      const multi = config && config.seriesField ? prepareSeries(rows, fields, config) : null;
      return <PieViz data={multi || prepareCategories(rows, fields, config)} />;
    }
    case 'bar': {
      const stacked = Boolean(config && config.stacked);
      const multi = config && config.seriesField ? prepareSeries(rows, fields, config) : null;
      const data =
        multi || (stacked ? prepareStacked(rows, config, fields) : prepareCategories(rows, fields, config));
      return <BarViz data={data} stacked={stacked} />;
    }
    case 'radar': {
      const multi = config && config.seriesField ? prepareSeries(rows, fields, config) : null;
      return <RadarViz data={multi || prepareCategories(rows, fields, config)} />;
    }
    case 'table':
    default:
      return <TableViz fields={fields} rows={rows} labels={config && config.labels} />;
  }
}
